import { render, staticRenderFns } from "./QLeadOrderHistoryTable.vue?vue&type=template&id=56b36ad9&"
import script from "./QLeadOrderHistoryTable.vue?vue&type=script&lang=js&"
export * from "./QLeadOrderHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports